import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { useGetDocentesPeriodo, useGetGrupo, useGetMatriculadosGrupo } from "hooks/useRequest";
import { useMemo, useState } from "react";

export const useListaDocentes = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { grupo, periodo } = queryString.parse(search);
  const [filteredDataDocentes, setFilteredData] = useState([]);

  const {
    data: dataDocentes,
    isFetching,
    isLoading,
  } = useGetDocentesPeriodo({
    //@ts-ignore
    id: parseInt(periodo as string, 10),
  });

  const { data: dataGrupo } = useGetGrupo({
    //@ts-ignore
    id: parseInt(grupo as string, 10),
  });

  const { data: matriculadosGrupo } = useGetMatriculadosGrupo({
    //@ts-ignore
    id: parseInt(grupo as string, 10),
  });

  const matriculadosIds = useMemo(() => {
    if (!matriculadosGrupo) return new Set<string>();
    return new Set(
      matriculadosGrupo.map((item: { docente: { id: string | number } }) =>
        String(item.docente.id)
      )
    );
  }, [matriculadosGrupo]);

  const isDocenteMatriculado = (docenteId: string | number) =>
    matriculadosIds.has(String(docenteId));

  const handleSearchChange = (value: any) => {
    const filteredDataDocentes = dataDocentes.docenteSet.filter(
      (docente: any) => {
        return docente.identificacion === value.target.value;
      }
    );
    setFilteredData(filteredDataDocentes);
  };

  const handleGoToAdd = () => {
    history.push({
      pathname: "/admin/matricular-docente/",
      search: `?grupo=${grupo}&periodo=${periodo}`,
      state: { tipoPeriodo: dataDocentes.tipoPeriodo.id },
    });
  };

  const handleGoToMatricular = (record: any) => {
    if (isDocenteMatriculado(record.id)) return;

    history.push({
      pathname: "/admin/matricular-docente/",
      search: `?grupo=${grupo}&periodo=${periodo}`,
      state: { docente: record, tipoPeriodo: dataDocentes.tipoPeriodo.id },
    });
  };

  return {
    grupo,
    periodo,
    dataDocentes,
    dataGrupo,
    filteredDataDocentes,
    isFetching,
    isLoading,
    isDocenteMatriculado,
    handleSearchChange,
    handleGoToAdd,
    handleGoToMatricular,
  };
};
